import * as React from 'react';
import { useSelector } from 'react-redux';

import { chatListSelector } from '../selectors';
import { IChat } from '../types/chatList';
import { ERoute } from '../types/route';

export const useChatsToDisplay = (): IChat[] => {
  const { chats, currentRoute, movedToArchiveChatIds, movedToSpamChatIds } = useSelector(chatListSelector);

  const chatsToDisplay = React.useMemo(() => {
    /**
     * Если находимся на странице активных чатов,
     * заблокированные чаты (в спаме) или архивные чаты
     * или чаты которые только что перенесли в спам или архив - не выводим
     */
    if (currentRoute === ERoute.Messages) {
      return chats.filter(
        chat =>
          chat.status !== 'blocked' &&
          chat.status !== 'archived' &&
          !movedToSpamChatIds.includes(chat.chatId as string) &&
          !movedToArchiveChatIds.includes(chat.chatId as string),
      );
    }

    /**
     * Если находимся на странице непрочитанных чатов,
     * заблокированные чаты (в спаме) или архивные чаты
     * или чаты которые только что перенесли в спам или архив - не выводим
     */
    if (currentRoute === ERoute.Unread) {
      return chats.filter(
        chat =>
          chat.status !== 'blocked' &&
          chat.status !== 'archived' &&
          !movedToSpamChatIds.includes(chat.chatId as string) &&
          !movedToArchiveChatIds.includes(chat.chatId as string),
      );
    }

    /**
     * Если находимся на странице важных чатов,
     * не важные чаты
     * заблокированные чаты (в спаме) или архивные чаты
     * или чаты которые только что перенесли в спам или архив - не выводим
     */
    if (currentRoute === ERoute.Starred) {
      return chats.filter(
        chat =>
          chat.status !== 'blocked' &&
          chat.status !== 'archived' &&
          !movedToSpamChatIds.includes(chat.chatId as string) &&
          !movedToArchiveChatIds.includes(chat.chatId as string) &&
          chat.isStarred,
      );
    }

    return chats;
  }, [currentRoute, chats, movedToSpamChatIds, movedToArchiveChatIds]);

  return chatsToDisplay;
};
